import _ from 'lodash';

export default function inReferenceColumn() {
    return {
        restrict: 'E',
        scope: {
            field: '&',
            value: '&',
            datastore: '<'
        },
        link: {
            pre: function(scope) {
                // const value = scope.value();
                scope.field = scope.field();
                scope.targetEntity = scope.field.targetEntity();
                scope.targetField = scope.field.targetField();
                const referencedEntries = scope.datastore()
                    .definitions[scope.targetEntity.name()]
                    .getAll();
                // scope.referencedEntry = _.find(referencedEntries, (e) => e.id === value);

                scope.$watch(scope.value, function(newVal, oldVal) {
                    scope.referencedEntry = _.find(referencedEntries, (e) => e.id === newVal);
                });

            }
        },
        template: '<column field="::targetField" entry="referencedEntry" entity="::targetEntity" datastore="::datastore()"></column>'
    };
}

inReferenceColumn.$inject = [];



// WEBPACK FOOTER //
// ./app/components/common/crud/column/inReferenceColumn.js